import type Parse from 'parse';

import { type Command } from '@telespot/core';
import { Mediator } from '@telespot/shared/mediator';
import {
  AddMembershipsHandler,
  ParseAddUserHandler,
  ParseExportOrganizationAffiliatesHandler,
  ParseGetUserRolesHandler,
  ParseListUsersHandler,
  ParseRoleRepository,
  ParseWorkspaceRepository,
  RemoveMembershipsHandler,
} from '@telespot/infrastructure/parse';

import {
  LIST_USERS,
  GRANT_ROLES,
  REVOKE_ROLES,
  ADD_USER,
  REMOVE_MEMBERSHIPS,
  ADD_MEMBERSHIPS,
  GET_USER_ROLES,
  GrantRolesHandler,
  RevokeRolesHandler,
} from '@authentication/use-cases';
import { EXPORT_ORGANIZATION_AFFILIATES } from '@telespot/management/use-cases';

export class UserClient {
  private readonly supportedCommands = {
    [LIST_USERS]: () => new ParseListUsersHandler(this.parse, {}),
    [GET_USER_ROLES]: () => new ParseGetUserRolesHandler(this.parse, {}),
    [GRANT_ROLES]: () => new GrantRolesHandler(new ParseRoleRepository(this.parse, {})),
    [REVOKE_ROLES]: () => new RevokeRolesHandler(new ParseRoleRepository(this.parse, {})),
    [ADD_USER]: () => new ParseAddUserHandler(),
    [REMOVE_MEMBERSHIPS]: () => new RemoveMembershipsHandler(this.parse, {}),
    [ADD_MEMBERSHIPS]: () => new AddMembershipsHandler(new ParseWorkspaceRepository(this.parse, {}), this.parse, {}),
    [EXPORT_ORGANIZATION_AFFILIATES]: () => new ParseExportOrganizationAffiliatesHandler(),
  };

  private readonly mediator = new Mediator({
    provider: this.supportedCommands,
  });

  constructor(private readonly parse: typeof Parse) {}

  public send<T extends keyof typeof this.supportedCommands>(command: Command<T>) {
    return this.mediator.send(command);
  }
}
